import * as globals from '@wandb/weave/common/css/globals.styles';
import {
  Button as SemanticButton,
  Message,
  Modal as SemanticModal,
} from 'semantic-ui-react';
import styled from 'styled-components';

export const Modal = styled(SemanticModal)`
  max-width: 400px;
`;

export const Header = styled.div`
  font-family: ${globals.fontName};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0em;
  padding: 24px 0px 0px 24px;
  text-align: left;
`;

export const Content = styled.div`
  font-family: ${globals.fontName};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 16px 24px 24px 24px;
`;

export const PendingMessage = styled(Message)`
  && {
    margin: 0 24px 24px 24px;
    padding: 18px 24px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0px 24px 24px 0px;
`;

export const CancelButton = styled(SemanticButton)`
  && {
    border: none;
    cursor: pointer;
    color: ${globals.MOON_800};
    font-weight: 600;
    background-color: ${globals.MOON_200};
  }
`;

export const InviteButton = styled(SemanticButton)`
  && {
    background-color: ${globals.TEAL_550};
    color: ${globals.WHITE};
    font-weight: 600;
    border: none;
    cursor: pointer;
  }
`;
